"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-arrows-expand-16><path fill-rule=evenodd clip-rule=evenodd d="M1 14a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H4.414l2.793-2.793a1 1 0 0 0-1.414-1.414L3 11.586V10a1 1 0 0 0-2 0v4Zm7.793-6.793a1 1 0 0 0 1.414 0L13 4.414V6a1 1 0 1 0 2 0V2a1 1 0 0 0-1-1h-4a1 1 0 1 0 0 2h1.586L8.793 5.793a1 1 0 0 0 0 1.414Z"></path></symbol>';
}
